import React, { useState } from 'react';

import getExtPath from 'shared-utils/src/getExtPath';

export default function Img({ src, alt, className, isFloorplan }) {
  const [error, setError] = useState(src.indexOf('mobileplaceholder') > -1);

  const handleError = () => setError(true);
  
  return (
    <img
      className={error ? 'err' : className || ''}
      src={!error ? `https://images-1.casa.it/${isFloorplan ? '800x600' : '360x265'}${src}` : getExtPath('common_images/common/gallery_img_plchldr_tras.png')}      
      alt={alt || ''}
      onError={handleError}
      data-type={isFloorplan ? 'f' : 'p'}
    />
  );
}
